import { h } from 'preact';
import { Text } from 'preact-i18n';
const HOP = Object.prototype.hasOwnProperty;

export let getAnnual = (rows) => {
	let annual = (q4, q3, q2, q1) => q4.map( (q, i) => i > 5 ? q + q3[i] + q2[i] + q1[i] : q);

	for (let i = 0; i < rows.length; i++) {
		if (rows[i][0] === 'Q4') {
			rows = rows.slice(i, i + 12);
			rows = [
				annual(rows[0], rows[1], rows[2], rows[3]),
				annual(rows[4], rows[5], rows[6], rows[7]),
				annual(rows[8], rows[9], rows[10], rows[11])
			];
			break;
		}
	}
	return rows;
};


/* Check if two objects have equal keys & values. */
export function shallowEqual(a, b) {
	if (a===b) return true;

	if (typeof a!=='object' || !a || typeof b!=='object' || !b) return false;

	for (let key in a) {
		if (!HOP.call(b, key) || a[key]!==b[key]) return false;
	}

	for (let key in b) {
		if (!HOP.call(a, key)) return false;
	}

	return true;
}

/**
 * Performs a shallow compare between `a` and `b`
 */
export function shallowDiffers(a, b) {
	for (let key in a) if (a[key]!==b[key]) return true;
	for (let key in b) if (!(key in a)) return true;
	return false;
}

/** Compare a <=> b, return greater, lessthan or equal value
 *	@TODO only used in one place, could just be inlined as a nested ternary
 */
export function gle(a, b, greater, lessthan, equal) {
	if (a > b) return greater;
	if (a < b) return lessthan;
	return equal;
}


/** Format a number based on a configuration object.
 *	@TODO option keys should be pascalCase, not CamelCase.
 *	@param {Number}		value
 *	@param {Object}		format
 *	@param {Number}		[format.Decimals=0]        Number of decimal places
 *	@param {Number}		[format.Default]           Default number to return when value is falsey
 *	@param {Boolean}	[format.Comma=false]       Add a comma thousands separator
 *	@param {Boolean}	[format.Compact=false]     Use compact magnitudes (K/M/B)
 *	@param {Boolean}	[format.Plus=false]        Display a plus sign in front of positive numbers
 *	@param {Boolean}	[format.inThousands=false] Display number in thousands
 *	@param {String}		[format.Prefix='']         Characters to prepend
 *	@param {String}		[format.Suffix='']         Characters to append
 */
export function formatNumber(v, f) {
	v = v || 0;
	if (! (f.Decimals >= 0)) f.Decimals = 0;
	if (v && v !== 0 && f.inThousands) v = Math.floor(v / 1e3);
	if (v === 0 || isNaN(v)) return f.Default;
	let o = []; //output
	if (v < 0) {
		o.push('-');
		v = Math.abs(v);
	}
	else if (v > 0 && f.Plus) {
		o.push('+');
	}

	if (f.Prefix !== null) {
		o.push(f.Prefix);
	}

	let ex = ''; // Extension: K/M/B
	if (f.Compact) {
		if (v >= 1000000000) {
			v /= 1000000000;
			ex = 'B';
			f.Decimals = 2;
		}
		else if (v >= 1000000) {
			v /= 1000000;
			ex = 'M';
			f.Decimals = 2;
		}
		else if (v >= 1000) {
			v /= 1000;
			ex = 'K';
			f.Decimals = 2;
		}
	}

	v = parseFloat(v).toFixed(f.Decimals);

	if (f.Comma) {
		let end = v.indexOf('.');
		if (end === -1) {
			end = v.length;
		}
		if (end > 3) {
			let parts = [];
			let fraction = v.substr(end,v.length);

			let i = end - 3;
			for (; i > 0; i -= 3) {
				parts.push(v.substr(i,3));
			}
			parts.push(v.substr(0,i+3));
			v = parts.reverse().join(',') + fraction;
		}
	}

	o.push(v);
	o.push(ex);
	if (f.Suffix !== null) {
		o.push(f.Suffix);
	}
	return o.join('');
}


/** Compare a current and previous value, and return a description of the change.
 *	@param {Number} current
 *	@param {Number} previous
 *	@returns {Object} `{ price, percent, class }`
 */
export function calcChange(now, prev) {
	let ret = { price: 0, percent: 0, class: 'unchanged' };
	if (now > 0 && prev > 0) {
		ret.price = now - prev;
		ret.percent = ret.price * 100 / prev;
		if (now > prev) {
			ret.class = 'positive';
		}
		else if (now < prev) {
			ret.class = 'negative';
		}
	}
	return ret;
}

export function formatDate(date) {
	if (!(date instanceof Date)) {
		date = new Date(date);
	}
	let d = !isNaN(date.getTime()) && date.toISOString().slice(0, 'YYYY-MM-DD'.length).split('-');
	return d
		? `${d[1]}/${d[2]}/${d[0]}`
		: `--/--/----`;
}

export function intlDateNode(date) {
	let [month, day, year] = formatDate(date).split('/');
	return <Text id="format.date.numberDate" fields={{ month, day, year }} />;
}


/** Format a timestamp based on age.
 *	@param {Date|String|Number} date	A Date instance or any variant thereof. Timestamps less than 2147483647 are treated as being in seconds.
 *	@TODO this is quite similar to how momentjs or http://npm.im/neatime work, might be better as a dependency.
 */
export function formatLastTradeTime(d) {
	if (! (d instanceof Date)) {
		if (d > 0 && d < 2147483647) {
			d = new Date(d * 1000); // Epoch Seconds
		}
		else {
			d = new Date(d); //Everything else - Epoch Milliseconds, time string, etc.
		}
	}
	if (d.getTimezoneOffset() <= 0) {
		//We are not in 'murica, so defer to broswer
		return d.toLocaleString();
	}
	//We are in 'murica, so we force all times to EST/EDT and then incorrectly label them EST
	let month = d.getMonth();
	let dst = 0;
	if (month > 2 && month < 10) {
		dst = 1;
	}
	else if (month === 2 || month === 10) { // Mar or Nov
		let dstBegin = new Date(d.getFullYear(),2,7,6,0,0,0); // 7AM GMT == DST switchover time, Mar 7 == earliest possible DST day
		let dow = dstBegin.getDay();
		if (dow > 0) {
			dstBegin.setDate(dstBegin.getDate() + (7 - dow)); // Adjust to 2nd sunday if the 7th isn't a sunday
		}

		let dstEnd = new Date(d.getFullYear(),10,1,6,0,0,0); // 7AM GMT == DST switchover time, Mar 7 == earliest possible DST day
		dow = dstEnd.getDay();
		if (dow > 0) {
			dstEnd.setDate(dstEnd.getDate() + (7 - dow)); // Adjust to 1st sunday if the 1st isn't a sunday
		}
		dst = (d >= dstBegin && d < dstEnd);
	}

	let tzOffset = dst ? -4 : -5;

	d = new Date(d.getTime() + (tzOffset * 3600000));

	let hour = d.getUTCHours();
	let pm = 0;
	if (hour >= 12) {
		hour -= 12;
		pm = 1;
	}
	if (hour === 0) {
		hour = 12;
	}

	let mins = d.getUTCMinutes();
	if (mins < 10) {
		mins = '0' + mins;
	}
	let secs = d.getUTCSeconds();
	if (secs < 10) {
		secs = '0' + secs;
	}

	let monthAbbr = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()];

	let AMorPM = (pm ? ' PM ' : ' AM ');
	if (d.getTime() < new Date().getTime() - (16 * 60 * 60 * 1000)) { //More than 16 hours old, show date
		return monthAbbr + ' ' + d.getDate() + ', ' + d.getFullYear() + ' - ' + hour + ':' + mins + ' ' + AMorPM + ' EST';
	}
	return hour + ':' + mins + ':' + secs + AMorPM + 'EST';
}

/** Return an average of number array.
 *	@param [Number, ...] values	An array of numbers.  Removes any undefined or null values before calculating average
 *	@returns {Number} returns number if has correct values.  If empty or full of null/undefined then returns undefined
 */
export function getAverage( values ) {
	let count=0, sum=0;
	for (let value of values) {
		if (value !== undefined && value !== null) {
			count++;
			sum += value;
		}
	}
	return count > 0 ? sum/count : undefined;
}

/** Return a formatted percentage string
 *	@param {percentage}
 * 	@returns {String} returns a string that looks like a percentage with '%' concatenated and correct number of decimal places
 */
export function percentFormatter(percent) {
	return formatNumber(percent, { Decimals: 2, Comma: true, Suffix: '%', Plus: true, Default: '0.00%' });
}

const HIGH_PRECISION_TYPE_CODES = ['CURRENCY', 'INTEREST'];

export function getDefaultPrecision(item={}) {
	return HIGH_PRECISION_TYPE_CODES.indexOf(item.SecurityTypeCode) > -1 ? 4 : 2;
}

/** Return a function that is bound to a default (overridable) precision and output value
 *	@param {stockInfo}
 *	@param {maxPrecision} number of digits after decimal point
 *	@returns {Function} returns a function that will generate a formatted string
 */
export function generatePriceFormatter(stockInfo, { Default, maxPrecision=Infinity, ...restFirstLevel }={} ) {
	let defaultPrecision = Math.min(maxPrecision, getDefaultPrecision(stockInfo));
	let defaultText = Default || `0.${Array(defaultPrecision+1).join('0')}`;
	return ( value, restSecondLevel={} ) => formatNumber(value, { Decimals: defaultPrecision, Default: defaultText, Comma: true, ...restFirstLevel, ...restSecondLevel });
}

/** Return the base currency for a given quote
 *	@param {quot}
 *	@param {maxPrecision} number of digits after decimal point
 *	@returns {String} returns a string that is the base currency of a quote
 */
export function getBaseCurrencyCode(quote={}) {
	return quote.ExchangeDefaultCurrency || (isCurrency(quote) ? quote.Symbol.substr(-3) : null);
}

/**
 *
 *	@param {quote}
 *	@returns {Boolean} Whether the quote represents a currency or not
 */
export function isCurrency(quote) {
	return quote && quote.SecurityTypeCode && quote.SecurityTypeCode.toUpperCase() === 'CURRENCY';
}

/**
 * Get the camel-cased version of a string
 *
 * @param {String} words - The sentence/words to camel case
 * @return {string}
 */
export function camel(words) {
	return words.split(' ')
		.map((w, i) => i ? `${w.slice(0,1).toUpperCase()}${w.slice(1, w.length).toLowerCase()}` : w.toLowerCase())
		.join('');
}

export function getDaysInMonth(m, y) {
	let d = new Date(y, m, 0);
	return d.getDate();
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/lib/util.js